<ngx-app-bar
  class="w-100"
  [title]="pageTitle"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="prospectus-container">
  <div class="pdf-container">
    @if (loading) {
      <app-spinner></app-spinner>
    }
    <pdf-viewer
      [src]="pdfBlob || pdfSrc"
      [render-text]="true"
      [original-size]="false"
      (after-load-complete)="loading = false"
      style="width: 100%; height: 100%"
    ></pdf-viewer>
  </div>
</div>
